import React, { FunctionComponent } from 'react';
import { DealerLaunchStepProps } from '../types';
import { Dealer } from '../../../types/dealerTypes';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import styles from '../styles.module.scss';
import { Radio } from '../../Input/Radio/Radio';

export const DealerLaunchAboutIsIndependent: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({
    defaultValues: dealer,
  });

  // for franchise dealers, the default CPO should be on
  const enableCPOForFranchise = (updatedData: Partial<Dealer>) => {
    const newUpdatedData = { ...updatedData };
    const shouldEnableCPO = !newUpdatedData?.isIndependent;
    let ownershipOptionsRules;
    let featureConfig;

    if (dealer.featureConfig) {
      featureConfig = {
        ...dealer.featureConfig,
        useCPO: { enabled: shouldEnableCPO },
      };
    }

    if (dealer.ownershipOptionsRules) {
      ownershipOptionsRules = {
        ...dealer.ownershipOptionsRules,
        CPO: {
          online: {
            cash: {
              ...dealer.ownershipOptionsRules?.CPO?.online?.cash,
              enabled: shouldEnableCPO,
            },
            purchase: {
              ...dealer.ownershipOptionsRules?.CPO?.online?.purchase,
              enabled: shouldEnableCPO,
            },
          },
          instore: {
            cash: {
              ...dealer.ownershipOptionsRules?.CPO?.instore?.cash,
              enabled: shouldEnableCPO,
            },
            purchase: {
              ...dealer.ownershipOptionsRules?.CPO?.instore?.purchase,
              enabled: shouldEnableCPO,
            },
          },
        },
      };
    }

    newUpdatedData.featureConfig = featureConfig;
    newUpdatedData.ownershipOptionsRules = ownershipOptionsRules;

    return nextStep(newUpdatedData);
  };

  return (
    <DealerLaunchFormCardLayout
      className={styles.aboutInfoStep}
      form={form}
      title="Tell Us About Your Dealership"
      subTitle="We want to know all about your dealership so that our online and instore solutions fit seamlessly with your dealership's brand."
      cardTitle="Are you an independent dealer?"
      cardSubTitle="Independent dealers are not expressly associated with any specific OEM brands. "
      prevStep={false}
      onFormSubmit={(data) => enableCPOForFranchise(data)}
    >
      <Radio
        className="flex-column"
        name="isIndependent"
        options={[
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ]}
        form={form}
        validation={{
          validate: (val: any) => {
            if (typeof val !== 'boolean') return 'A selection is required.';
            return true;
          },
        }}
      />
    </DealerLaunchFormCardLayout>
  );
};
